import { clientFetch, Uri } from '../utils/fetch';
import { packageModel, priceCalendarModel } from '../models/package';

// Fetch price calendar only for allowed destinations, otherwise return null.
// Temporarily hardcoded list of allowed destinations for A/B-Testing.
// LH = Long Haul, SH = Short Haul, City = City Destination
const allowedPriceCalendarDestinations = [
  // Long Haul Destinations
  'resortId=329', // Maldiverna
  'resortId=171', // Mauritius
  'areaId=85', // Bali
  'areaId=137', // Phuket
  'areaId=116', // Krabi
  'areaId=188707', // Mexico, Cancun-området
  'resortId=188707', // Mexico, Cancun-området
  'resortId=3819', // Zanzibar

  // Short Haul Destinations
  'areaId=97', // Costa del Sol
  'areaId=108', // Gran Canaria
  'areaId=149', // Teneriffa
  'areaId=127', // Mallorca
  'areaId=60693', // Malta
  'areaId=124', // Madeira
  'resortId=322', // Marocko - Agadir
  'resortId=333', // Marocko - Marrakech
  'resortId=78624', // Marocko - Taghazout

  // City Destinations
  'resortId=316', // London
  'resortId=309', // Paris
  'resortId=269', // Rom
  'resortId=343', // Barcelona
];

export const fetchPriceCalendar = async (siteSettings) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;
  const query = {
    ...priceCalendarModel,
    siteId,
  };

  const uri = new Uri({ domain: apiUrl, path: '/api/package/priceCalendar', query });

  // Only fetch price calendar if the destination is allowed, otherwise return null.
  if (!allowedPriceCalendarDestinations.some((dest) => uri.query.includes(dest))) {
    return null;
  }

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);
  return response;
};

export const fetchHotels = async (siteSettings, userId, signal = null) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;
  const query = {
    ...packageModel,
    userId,
    siteId,
    ...(siteId === 18 && { showAll: true }),
  };

  const uri = new Uri({ domain: apiUrl, path: '/api/package/hotels', query });
  const response = await clientFetch.getJsonByProxy(uri, baseUrl, true, signal);

  return response;
};

export const fetchUpsell = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;
  const query = {
    ...packageModel,
    userId,
    siteId,
  };

  const uri = new Uri({ domain: apiUrl, path: '/api/package/upsell', query });
  const response = await clientFetch.getJsonByProxy(uri, baseUrl);

  return response;
};

export const fetchPriceMatrix = async (siteSettings, userId) => {
  const { siteId, apiUrl, HotelId, baseUrl, newCheckout } = siteSettings;
  const query = {
    ...packageModel,
    userId,
    siteId,
    newCheckout,
    ...(siteId === 18 && { showAllRooms: true }),
  };

  // If hotelId not in browser url, use hotelId from req.query from Idun.
  if (!query.hotelId && HotelId) {
    query.hotelId = HotelId;
  }

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/package/price-matrix',
    query,
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);

  return response;
};

export const fetchFlights = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl, newCheckout } = siteSettings;
  const query = {
    ...packageModel,
    userId,
    siteId,
    newCheckout,
  };

  const uri = new Uri({ domain: apiUrl, path: '/api/package/flights', query });
  const response = await clientFetch.getJsonByProxy(uri, baseUrl);

  return response;
};

export const addPackageToCart = async (model, siteSettings) => {
  const { apiUrl, baseUrl } = siteSettings;

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/package/addToCart',
    query: model,
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);

  return response;
};
